<template>
	<div id="undraw_developer_activity">
		<svg
			data-name="male_avatar"
			xmlns="http://www.w3.org/2000/svg"
			width="1144"
			height="617"
			viewBox="0 0 1144 617"
		>
			<defs>
				<path d="M0 0L1144 0L1144 617.32L0 617.32L0 0Z" id="path_1" />
				<clipPath id="mask_1">
					<use xlink:href="#path_1" />
				</clipPath>
			</defs>
			<g transform="translate(0.5 0.5)">
				<path
					d="M0 0L1144 0L1144 617.32L0 617.32L0 0Z"
					class="Background"
					fill="none"
					fill-rule="evenodd"
					stroke="none"
				/>
				<g clip-path="url(#mask_1)">
					<path
						d="M1144 396.19C1144.01 412.983 1141.7 429.674 1137.14 445.812C1132.74 461.363 1126.26 476.249 1117.88 490.07C1117.88 540.17 1084.06 583.47 1034.97 604.07C1014.46 612.591 992.453 616.943 970.241 616.87L217.171 616.87C176.92 616.87 139.62 606.01 109.03 587.51C100.276 582.24 91.9711 576.256 84.2006 569.62C50.2005 540.4 29.1205 500.02 29.1205 455.42C10.0386 426.037 -0.0794847 391.735 0.000471339 356.7C0.000471339 283.34 43.3905 220.26 105.55 192.41C113.805 188.714 122.334 185.664 131.061 183.29C134.147 182.45 137.267 181.697 140.42 181.03C148.827 179.24 157.353 178.07 165.93 177.53C169.03 177.337 172.147 177.227 175.28 177.2L177 177.2C180.46 177.2 183.89 177.32 187.3 177.52L188.42 175.62C189.794 173.327 191.2 171.057 192.64 168.81C195.24 164.717 197.967 160.683 200.82 156.71C203.807 152.517 206.924 148.39 210.171 144.33L211.001 143.33C212.84 141.037 214.721 138.77 216.641 136.53C222.641 129.537 228.974 122.753 235.641 116.18C307.751 45.5 420.721 0 547.721 0C646.541 0 736.871 27.55 806.06 73.07C832.272 58.2366 861.883 50.4533 892.001 50.48C989.741 50.48 1069 130.85 1069 229.99C1068.99 236.267 1068.65 242.535 1068 248.774C1115.81 282.619 1144.16 337.612 1144 396.19L1144 396.19Z"
						transform="translate(-0.00048828125 0.040039062)"
						id="Shape"
						:fill="currentStoreTheme.color"
						fill-opacity="0.1"
						fill-rule="evenodd"
						stroke="none"
					/>
					<g id="activity" transform="translate(105.54999 111.02002)">
						<path
							d="M18.9966 0L18.9966 20.35L0 20.35C5.95226 13.3633 12.2845 6.58002 18.9966 0L18.9966 0Z"
							transform="translate(111.090225 5.1599736)"
							id="Shape"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(139.44514 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(174.2989 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(209.16269 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(244.01651 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(278.88028 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(313.7441 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(348.59787 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(383.46164 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(418.31543 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(453.1792 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(488.043 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(522.8967 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(557.7605 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(592.6244 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(627.47815 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(662.3419 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(697.1957 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(732.05945 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(766.9232 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(801.77704 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(836.64087 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(871.4946 0)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M8.17855 0L8.17855 12.1L0 12.1C2.59954 7.98001 5.32573 3.94669 8.17855 0L8.17855 0Z"
							transform="translate(87.05451 45.720036)"
							id="Shape"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(104.581375 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(139.44514 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(174.2989 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(209.16269 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(244.01651 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(278.88028 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(313.7441 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(348.59787 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(383.46164 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(418.31543 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(453.1792 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(488.043 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(522.8967 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(557.7605 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(592.6244 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(627.47815 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(662.3419 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(697.1957 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(732.05945 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(766.9232 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(801.77704 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(836.64087 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(871.4946 32.31)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M25.5054 3.05176e-05L25.5054 17.83L0 17.83L0 9.12002C8.25271 5.42361 16.7802 2.37445 25.5055 0L25.5054 3.05176e-05Z"
							transform="translate(0 72.310005)"
							id="Shape"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M25.5054 0L25.5054 23.59L0 23.59L0 3.5L25.5054 0L25.5054 0Z"
							transform="translate(34.863773 66.549995)"
							id="Polygon"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(69.7176 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(104.581375 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(139.44514 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(174.2989 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(209.16269 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(244.01651 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(278.88028 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(313.7441 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(348.59787 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(383.46164 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(418.31543 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(453.1792 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(488.043 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(522.8967 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(557.7605 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(592.6244 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(627.47815 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(662.3419 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(697.1957 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(732.05945 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(766.9232 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(801.77704 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(836.64087 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(871.4946 64.63001)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(0 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(34.863773 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(69.7176 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(104.581375 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(139.44514 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(174.2989 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(209.16269 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(244.01651 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(278.88028 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(313.7441 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(348.59787 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(383.46164 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(418.31543 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(453.1792 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(488.043 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(522.8967 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(557.7605 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(592.6244 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(627.47815 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(662.3419 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(697.1957 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(732.05945 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(766.9232 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(801.77704 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(836.64087 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(871.4946 96.94002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(0 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(34.863773 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(69.7176 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(104.581375 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(139.44514 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(174.2989 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(209.16269 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(244.01651 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(278.88028 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(313.7441 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(348.59787 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(383.46164 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(418.31543 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(453.1792 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(488.043 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(522.8967 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(557.7605 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(592.6244 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(627.47815 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(662.3419 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(697.1957 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(732.05945 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(766.9232 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(801.77704 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(836.64087 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(871.4946 129.26003)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(0 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(34.863773 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(69.7176 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(104.581375 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(139.44514 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(174.2989 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(209.16269 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(244.01651 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(278.88028 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(313.7441 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(348.59787 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(383.46164 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(418.31543 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(453.1792 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(488.043 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(522.8967 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(557.7605 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(592.6244 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(627.47815 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(662.3419 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(697.1957 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(732.05945 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(766.9232 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(801.77704 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(836.64087 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.4"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(871.4946 161.57002)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(0 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(34.863773 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(69.7176 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(104.581375 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(139.44514 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.7"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(174.2989 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(209.16269 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(244.01651 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(278.88028 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(313.7441 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(348.59787 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(383.46164 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(418.31543 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(453.1792 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5055 0L25.5055 25.51L0 25.51L0 0Z"
							transform="translate(488.043 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(522.8967 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(557.7605 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(592.6244 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(627.47815 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(662.3419 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(697.1957 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(732.05945 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(766.9232 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(801.77704 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(836.64087 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-opacity="0.2"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 0L25.5054 0L25.5054 25.51L0 25.51L0 0Z"
							transform="translate(871.4946 193.89005)"
							id="Rectangle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
					</g>
					<g id="Body" transform="translate(526.88745 292.8301)">
						<path
							d="M0 34.87C0 15.6118 15.6118 0 34.87 0C54.1282 0 69.74 15.6118 69.74 34.87C69.74 54.1282 54.1282 69.74 34.87 69.74C15.6118 69.74 0 54.1282 0 34.87Z"
							transform="translate(172.76265 36.18991)"
							id="Circle"
							fill="#767D9F"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0.893372 26.6999C4.37335 41.8866 7.32666 57.1866 9.75336 72.5999C10.4833 77.1799 11.1334 82.0099 9.47333 86.3399C8.08332 89.9499 5.25336 92.7699 3.03333 95.9299C0.813294 99.09 -0.866699 103.14 0.483338 106.76C1.83337 110.38 5.77332 112.36 9.53333 113.38C20.2933 116.28 31.7633 114.17 42.4733 111.03C47.3225 109.782 51.9716 107.856 56.2833 105.31C60.8233 102.43 64.5434 98.43 67.9633 94.31C83.5733 75.38 93.7934 52.66 103.413 30.08C90.873 31.2213 78.5498 26.2563 70.3034 16.74C66.3634 12.11 63.4734 5.66 65.6934 0C59.1834 3.57001 51.4534 3.81 44.4434 6.25C40.0961 7.91034 35.9116 9.96909 31.9434 12.4C27.1567 15.1667 22.3967 17.9867 17.6633 20.86C12.2534 24.1199 7.18335 27.0199 0.893372 26.6999L0.893372 26.6999Z"
							transform="translate(204.92929 0)"
							id="Shape"
							fill="#AE6E79"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M150.29 32.184C144.18 44.074 136.23 55.504 124.88 62.584C113.53 69.6641 98.25 71.584 86.88 64.584C81.28 61.1641 77.0399 55.964 72.15 51.584C67.26 47.204 61.15 43.454 54.58 44.024C47.34 44.6541 41.67 50.304 36.82 55.7141C29.46 63.934 22.35 72.504 17.14 82.2341C7.13995 100.934 4.76996 122.794 5.20996 143.994C5.64996 165.194 8.71997 186.284 8.78998 207.484C8.88995 233.564 4.46997 259.434 0 285.124C41.1 280.064 82.25 291.124 123.44 295.314C149.8 298.024 176.36 297.964 202.86 297.894C207.52 297.894 212.48 297.774 216.36 295.194C218.732 293.464 220.65 291.186 221.95 288.554C225.61 281.804 227.08 274.104 228.1 266.494C230.69 247.274 230.77 227.814 230.84 208.414C231.02 161.414 231.19 114.244 225.22 67.6141C223.75 56.1441 221.87 44.6141 217.47 33.8841C213.07 23.1541 205.89 13.2841 195.85 7.53406C189.4 3.83405 174.45 -2.60596 166.85 1.12405C158.32 5.28403 154.38 24.224 150.29 32.184L150.29 32.184Z"
							transform="translate(128.46272 20.695862)"
							id="Shape"
							fill="#767D9F"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M8.72229 173.127C7.1723 144.127 0.862305 113.177 14.2923 87.437C17.5923 81.117 5.75232 73.227 9.41229 67.107C13.8788 59.6454 17.2658 51.5887 19.4724 43.177C20.2323 40.287 20.8423 37.227 20.1223 34.327C18.7923 29.037 13.5623 25.887 9.12232 22.667C4.22229 19.107 1.70233 8.25699 0.122314 2.38699C-1.4577 -3.483 12.6923 3.58701 18.3823 1.49698C26.2824 -1.39304 36.3223 0.426971 44.2023 3.35696C48.6024 4.97696 53.3823 5.11697 58.0723 5.23697C67.1823 5.47696 76.3223 5.70697 85.3623 4.58698C89.4223 4.07697 93.4923 3.30698 97.5723 3.53699C107.982 4.12698 117.032 11.247 123.192 19.667C129.352 28.087 133.272 37.897 138.322 47.017C142.532 54.617 147.552 61.797 151.142 69.707C154.322 76.707 156.332 84.227 158.322 91.707L163.452 110.897C164.35 113.642 164.776 116.52 164.712 119.407C164.452 122.477 163.092 125.337 161.712 128.067C156.494 138.185 150.237 147.734 143.042 156.557C132.252 169.787 119.152 181.717 112.742 197.557C110.242 203.727 108.852 210.287 107.582 216.827C102.462 242.984 98.8227 269.41 96.6822 295.978C84.9976 290.57 72.7495 286.475 60.1624 283.767C53.8878 282.425 47.5451 281.423 41.1622 280.767C35.5723 280.187 28.3623 281.287 23.0423 279.767C14.1423 277.237 13.1623 262.187 11.8123 254.307C9.65234 241.757 9.22229 228.987 9.14234 216.307C9.0423 201.887 9.49231 187.497 8.72229 173.127L8.72229 173.127Z"
							transform="translate(273.07034 12.4729)"
							id="Shape"
							fill="#4C4981"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M86.3426 13.5001C90.5526 37.5001 95.1926 61.5701 104.343 84.1201C104.113 84.34 103.883 84.54 103.653 84.7401C102.843 85.4301 102.003 86.0801 101.123 86.7401C99.0726 88.1801 96.8226 89.4 95.1226 91.28C94.4789 91.9995 93.9707 92.8295 93.6226 93.73C92.9872 95.1522 92.9872 96.7777 93.6226 98.2C88.8526 100.31 83.3126 99.66 77.9626 99.46C73.3526 99.29 68.8826 99.46 65.1826 101.99C60.0425 105.53 58.4926 112.33 57.6625 118.51C57.3558 120.763 57.0925 123.02 56.8726 125.28C56.6592 127.38 56.4859 129.487 56.3525 131.6C55.8992 138.591 55.8358 145.602 56.1625 152.6C56.2159 153.88 56.2859 155.16 56.3726 156.44C40.0325 156.05 25.1426 147.53 11.0526 139.25C7.83258 137.36 4.51257 135.37 2.42255 132.25C0.496765 129.186 -0.318665 125.553 0.11261 121.96C0.11261 121.45 0.202637 120.96 0.272583 120.44C0.720398 117.473 1.48816 114.562 2.5625 111.76C6.97083 99.8241 13.4689 88.7682 21.7526 79.11C25.3326 74.9301 29.3626 70.84 31.0326 65.59C31.7626 63.3 32.0326 60.8701 32.7726 58.59C36.0926 48.71 48.0726 44.04 52.1726 34.45C53.1726 32.16 53.6326 29.65 54.8726 27.45C55.989 25.6216 57.4291 24.012 59.1226 22.7C59.8526 22.09 60.6126 21.5 61.3626 20.91C68.3893 15.4034 75.1592 9.58667 81.6726 3.46002C82.8859 2.32001 84.0859 1.16669 85.2726 0C85.1141 4.52606 85.4731 9.05542 86.3425 13.5001L86.3426 13.5001Z"
							transform="translate(0 117.86981)"
							id="Shape"
							fill="#4C4981"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M101.79 21.7904C100.35 23.3104 98.7899 24.7404 97.2598 26.1604L96.8499 26.5304L95.2299 28.0304C92.2896 30.5681 89.7448 33.5308 87.6799 36.8204L87.5099 37.1004C82.4099 46.2304 84.2999 57.4704 85.7199 67.8404C87.4812 80.7631 88.2734 93.7995 88.0899 106.84C87.8299 124.84 85.7099 142.72 85.6699 160.7C85.6699 164.78 85.76 168.85 85.94 172.93C86.2299 179.56 86.7299 186.18 87.33 192.8C87.98 200.06 88.76 207.31 89.4899 214.56C90.07 220.17 90.6199 225.77 91.08 231.37C91.31 234.27 91.53 237.16 91.71 240.06C91.92 243.46 92.09 246.87 92.19 250.27L92.19 250.27C92.26 252.43 92.2999 254.58 92.2999 256.74C92.2999 257.97 92.2999 259.19 92.2999 260.41C92.2999 262.75 92.2366 265.084 92.1099 267.41C91.9766 270.404 91.7733 273.404 91.5 276.41C91.19 279.68 90.64 283.25 88.34 285.55C88.2 285.69 88.05 285.82 87.9 285.95L84.66 285.55C62.3248 282.876 39.7761 282.474 17.3598 284.35C17.85 280.97 18.3 277.6 18.74 274.21C18.94 272.61 19.14 271 19.33 269.39C19.5501 267.55 19.76 265.71 19.96 263.87C20.19 261.87 20.4 259.87 20.6 257.87C21.1201 252.717 21.5767 247.56 21.97 242.4C22.5501 234.874 22.9901 227.334 23.29 219.78C23.4367 216.174 23.5501 212.564 23.6301 208.95C23.7434 204.47 23.7967 199.987 23.79 195.5C23.79 191.14 23.7534 186.774 23.6801 182.4C23.6801 180.96 23.6201 179.52 23.5001 178.09C23.4139 176.803 23.2368 175.523 22.97 174.26C22.2275 171.349 21.2235 168.511 19.97 165.78C19.7501 165.26 19.54 164.78 19.33 164.23C19.21 163.96 19.1 163.68 18.99 163.41C24.75 158.28 28.85 151.41 32.79 144.65C39.18 133.76 45.72 122.39 46.79 109.81C47.86 97.2303 41.61 83.1003 29.59 79.2603C26.32 78.2603 22.86 77.9803 19.49 77.3903C16.31 76.8303 9.67999 75.5603 6 73.2803C4 75.3337 2 77.3503 0 79.3303C0.121338 76.3093 0.859802 73.3451 2.16998 70.6202L3.58997 70.6903C3.47424 70.37 3.41998 70.0308 3.42993 69.6903C3.42999 68.6203 4.16998 67.4103 5.75 66.0703C10.46 62.0703 17.87 61.1803 20.84 55.7703C22.08 53.5203 22.29 50.8403 23.29 48.4803C26.16 41.7504 34.4 39.2703 39.3601 33.8904C44.3201 28.5104 45.5601 20.8904 49.5701 14.8904C52.5654 10.5088 56.7202 7.04651 61.5701 4.89035C61.9701 4.70035 62.3801 4.51035 62.79 4.34036C71.09 0.790375 80.95 -0.0196228 89.5501 0.000366211C92.8901 0.000366211 101.55 0.100372 105.79 1.79037C106.478 2.0361 107.108 2.42075 107.64 2.92038C112.16 7.84039 105.13 18.2304 101.79 21.7904L101.79 21.7904Z"
							transform="translate(85.32276 38.599487)"
							id="Shape"
							fill="#4C4981"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M18.7204 2.58447C34.3243 -2.11304 51.16 -0.358826 65.4604 7.45447C72.6604 11.4545 79.1204 17.0345 83.0804 24.2345C89.0304 35.0345 88.7704 48.0545 88.3504 60.3845C88.1404 66.5545 87.8704 72.9445 85.1504 78.4845C82.0004 84.8945 76.0604 89.2945 70.0004 92.8945C66.204 95.3165 62.0449 97.1159 57.6804 98.2245C50.9605 99.6845 43.9804 98.4445 37.2105 97.2245C29.8505 95.8645 21.9504 94.2245 16.8405 88.7445C13.8405 85.5645 12.2004 81.4345 10.5804 77.3945C8.25379 71.5612 5.92047 65.7346 3.58044 59.9146C-0.469544 49.8046 -1.83954 41.3945 3.51044 31.5446C5.94043 27.0546 8.91046 22.8546 11.3104 18.3345C12.5104 16.0345 16.8104 3.1745 18.7204 2.58447L18.7204 2.58447Z"
							transform="translate(69.11219 105.935425)"
							id="Shape"
							fill="#4C4981"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M112.74 19.3649C117.25 18.945 121.82 18.2349 125.88 16.2349C130.88 13.7449 134.77 9.4549 139.4 6.29492C149.58 -0.705078 163.2 -1.64508 174.87 2.37494C186.54 6.39496 196.28 15.0049 203.1 25.2849C207.63 32.1349 211.03 40.8749 207.83 48.435C206.732 50.7458 205.348 52.9095 203.71 54.8749L195.37 65.7749C193.786 68.0663 191.879 70.1173 189.71 71.865C186.59 74.135 182.71 75.065 178.89 75.625C168.74 77.105 158.41 76.265 148.18 76.945C130.61 78.115 113.45 83.7751 95.84 83.585C85.72 83.475 75.73 81.435 65.84 79.3951L22.07 70.3951C14.45 68.835 5.84003 66.555 2.25 59.6451C0.640015 56.5351 0.340027 52.935 0.150024 49.435C-0.369995 39.795 0.150024 29.075 6.83002 22.125C13.11 15.605 23.04 13.545 30.54 8.72498C39.72 2.815 42.7501 4.72498 52.4301 9.16498C71.3149 17.7174 92.0932 21.2316 112.74 19.3649L112.74 19.3649Z"
							transform="translate(37.542545 200.77496)"
							id="Shape"
							fill="#AE6E79"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M112.74 19.3649C117.25 18.945 121.82 18.2349 125.88 16.2349C130.88 13.7449 134.77 9.4549 139.4 6.29492C149.58 -0.705078 163.2 -1.64508 174.87 2.37494C186.54 6.39496 196.28 15.0049 203.1 25.2849C207.63 32.1349 211.03 40.8749 207.83 48.435C206.732 50.7458 205.348 52.9095 203.71 54.8749L195.37 65.7749C193.786 68.0663 191.879 70.1173 189.71 71.865C186.59 74.135 182.71 75.065 178.89 75.625C168.74 77.105 158.41 76.265 148.18 76.945C130.61 78.115 113.45 83.7751 95.84 83.585C85.72 83.475 75.73 81.435 65.84 79.3951L22.07 70.3951C14.45 68.835 5.84003 66.555 2.25 59.6451C0.640015 56.5351 0.340027 52.935 0.150024 49.435C-0.369995 39.795 0.150024 29.075 6.83002 22.125C13.11 15.605 23.04 13.545 30.54 8.72498C39.72 2.815 42.7501 4.72498 52.4301 9.16498C71.3149 17.7174 92.0932 21.2316 112.74 19.3649L112.74 19.3649Z"
							transform="translate(37.542545 200.77496)"
							id="Shape"
							fill="#000000"
							fill-opacity="0.05"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M258.936 5.11829C246.656 9.86829 234.306 14.6383 221.446 17.4683C199.886 22.2183 177.326 21.4683 155.936 26.8982C144.636 29.7782 133.406 34.4182 121.796 33.4783C116.606 33.0583 111.596 31.4783 106.546 30.2782C78.1755 23.2782 45.9255 25.5482 22.8856 43.5482C15.0056 49.6983 8.55554 57.3683 2.70557 65.5482C0.171021 69.1255 -0.634583 73.6474 0.508667 77.8799C1.65186 82.1123 4.62457 85.6137 8.61554 87.4283C17.5756 91.5487 27.1736 94.1089 36.9955 94.9982C50.1256 96.1582 63.3156 94.2982 76.3756 92.4383C95.7556 89.6883 115.146 86.9283 134.476 83.8383C141.416 82.7283 148.356 81.5783 155.336 80.6983C205.566 74.3483 256.706 82.0683 307.066 76.7683C312.156 76.2283 317.336 75.5284 321.966 73.3583C333.686 67.8583 339.486 53.3583 337.066 40.6183C334.645 27.8783 325.306 17.2883 314.066 10.7883C304.646 5.31836 294.486 3.10834 283.996 0.78833C274.256 -1.48169 268.316 1.51831 258.936 5.11829L258.936 5.11829Z"
							transform="translate(67.11707 201.31158)"
							id="Shape"
							fill="#AE6E79"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M130.999 42.6466C136.539 49.9066 137.719 59.6466 137.119 68.7366C136.519 77.8266 134.359 86.8166 134.039 95.9466C133.599 108.467 136.619 120.947 136.109 133.427C135.749 142.157 133.679 150.717 131.229 159.097C128.339 168.987 124.159 179.617 115.029 184.367C102.909 190.677 77.4888 187.127 64.7388 192.067C65.8988 184.837 77.0188 174.367 78.1788 167.137C78.9788 162.137 79.7888 156.997 78.9288 151.987C77.8288 145.597 74.0788 139.927 69.6288 135.207C62.5488 127.697 53.3088 122.047 43.1588 120.207C33.0089 118.367 8.15882 119.877 0.0388184 126.287C-0.961182 119.667 17.6388 113.287 24.1788 111.857C27.4388 111.127 31.1788 111.537 33.7888 109.467C38.7888 105.547 35.1588 97.7366 35.3988 91.4666C35.5888 86.4666 38.5088 81.8866 39.0988 76.8866C40.0988 68.8866 34.8789 60.7365 36.9288 52.8866C37.6889 49.9865 39.3789 47.4366 40.5488 44.6765C44.1088 36.2265 42.5488 26.5865 40.6488 17.6065C39.4688 11.9665 38.3188 5.60654 41.4588 0.796539C44.3688 -3.69345 52.6288 12.2965 57.9188 11.5565C75.3888 9.10654 91.1988 -3.84348 105.309 6.75656C112.499 12.1566 113.439 17.7566 116.309 25.4666C119.099 32.8065 126.329 36.5666 130.999 42.6466L130.999 42.6466Z"
							transform="translate(302.78384 87.62332)"
							id="Shape"
							fill="#000000"
							fill-opacity="0.1"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M130.999 49.4077C136.539 56.6678 137.719 66.4077 137.119 75.4978C136.519 84.5878 134.359 93.5778 134.039 102.708C133.599 115.228 136.619 127.708 136.109 140.188C135.749 148.918 133.679 157.478 131.229 165.858C128.339 175.748 124.159 186.378 115.029 191.128C102.909 197.438 77.4888 193.888 64.7388 198.828C65.8988 191.598 77.0188 181.128 78.1788 173.898C78.9788 168.898 79.7888 163.758 78.9288 158.748C77.8288 152.358 74.0788 146.688 69.6288 141.968C62.5488 134.458 53.3088 128.808 43.1588 126.968C33.0089 125.128 8.15882 126.638 0.0388184 133.048C-0.961182 126.428 17.6388 120.048 24.1788 118.618C27.4388 117.888 31.1788 118.298 33.7888 116.228C38.7888 112.308 35.1588 104.498 35.3988 98.2278C35.5888 93.2278 38.5088 88.6477 39.0988 83.6477C40.0988 75.6477 34.8789 67.4977 36.9288 59.6477C37.6889 56.7477 39.3789 54.1977 40.5488 51.4377C44.1088 42.9877 42.5488 33.3477 40.6488 24.3677C39.4688 18.7277 38.3188 12.3677 41.4588 7.55771C44.3688 3.06772 50.0588 1.36771 55.3488 0.617706C73.0607 -1.77805 91.0069 2.85208 105.349 13.5177C112.539 18.9178 113.479 24.5177 116.349 32.2278C119.099 39.5677 126.329 43.3277 130.999 49.4077L130.999 49.4077Z"
							transform="translate(305.78384 80.86215)"
							id="Shape"
							fill="#4C4981"
							fill-rule="evenodd"
							stroke="none"
						/>
					</g>
					<path
						d="M925.97 58.9399L925.97 88.84C905.457 97.3615 883.453 101.713 861.24 101.64L591.55 101.64C591.41 101.78 591.26 101.91 591.11 102.04L587.87 101.64L108.14 101.64C67.89 101.64 30.59 90.78 0 72.28L0 26.63L230.72 0L230.9 0L365.26 11.38L400.03 14.38L418.09 15.91L455.47 19.08L474.7 20.71L502.7 23.09L506.64 23.42L526.82 25.13L554.2 27.38L592.7 30.64L656.88 36.09L702.03 39.92L776.17 46.21L790.27 47.4L791.79 47.53L793.11 47.64L811.73 49.22L832.17 50.96L834.54 51.16L925.97 58.9399Z"
						transform="translate(109.02997 515.28)"
						id="Shape"
						fill="#504F60"
						fill-rule="evenodd"
						stroke="none"
					/>
					<g id="Computer" transform="translate(301.56128 341.97412)">
						<path
							d="M300.35 49.35L11.21 0L0 56.69L132.54 72.56L173.35 77.67L285.61 55.56L300.35 49.35L300.35 49.35Z"
							transform="translate(162.08876 181.7959)"
							id="Polygon"
							fill="#9C9CA1"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 27.3191L144.86 0.0891113C146.327 -0.19165 147.844 0.198364 148.993 1.15259C150.143 2.10681 150.806 3.52515 150.8 5.01917L150.8 5.01917C150.806 7.43469 149.085 9.50952 146.71 9.9491L5.23999 36.4391L0 27.3191Z"
							transform="translate(312.76877 229.30676)"
							id="Shape"
							fill="#9C9CA1"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0.438721 33.7459L54.8087 234.686C56.1747 239.727 60.5199 243.395 65.7187 243.896L310.439 267.406C314.486 267.796 318.471 266.2 321.13 263.124C323.788 260.048 324.791 255.874 323.819 251.926L264.279 9.54587C262.816 3.5965 257.268 -0.424744 251.159 0.0358582L11.5687 17.9559C7.84424 18.2452 4.44272 20.1801 2.29044 23.2334C0.138184 26.2868 -0.54068 30.1408 0.438721 33.7458L0.438721 33.7459Z"
							id="Shape"
							fill="#9C9CA1"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 30.9223C0 16.3766 6.82436 3.45707 19.5 0.422304C32.1756 -2.61246 47.5911 11.2238 49.5 25.4223C51.4089 39.6209 45.4937 57.3202 30 59.9224C14.5063 62.5246 0 45.4679 0 30.9223Z"
							transform="translate(123.43866 114.4236)"
							id="Ellipse"
							:fill="currentStoreTheme.color"
							style="mix-blend-mode: screen"
							fill-rule="evenodd"
							stroke="#808080"
							stroke-width="0"
						/>
					</g>
					<g id="Hearphone" transform="translate(704.85333 295.74)">
						<path
							d="M0 27.25C0 12.2002 12.0435 0 26.9 0C41.7565 0 53.8 12.2002 53.8 27.25C53.8 42.2998 41.7565 54.5 26.9 54.5C12.0435 54.5 0 42.2998 0 27.25Z"
							transform="translate(55.35669 64.69)"
							id="Ellipse"
							fill="#FFFFFF"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M13.2 0.430267C13.2 0.430267 18.87 17.2903 2.14001 24.3803L0 28.1203L10.48 38.4603C10.48 38.4603 23.4 14.8903 22 6.52026C22 6.52026 20 -1.97974 13.2 0.430267L13.2 0.430267Z"
							transform="translate(91.14673 41.799744)"
							id="Shape"
							fill="#FFFFFF"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M0 25.94C0 11.6137 11.6137 0 25.94 0C40.2663 0 51.88 11.6137 51.88 25.94C51.88 40.2663 40.2663 51.88 25.94 51.88C11.6137 51.88 0 40.2663 0 25.94Z"
							transform="translate(59.40674 67.31)"
							id="Circle"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M32.94 52.15L28.82 45.35L22.82 44.5C24.1 22.11 18.29 15.44 18.29 15.44L16.94 15.31L11.06 14.74L0 3.26001L0 0C15.54 1.85001 24.13 9.23001 28.77 17.88C36.97 33.06 32.94 52.15 32.94 52.15L32.94 52.15Z"
							transform="translate(80.33673 0)"
							id="Shape"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M16.94 7.93002L16.94 12.05L11.06 11.48L0 0C0 0 17.11 3.83005 16.94 7.93002L16.94 7.93002Z"
							transform="translate(80.38672 3.2599792)"
							id="Shape"
							fill="#000000"
							fill-opacity="0.1"
							fill-rule="evenodd"
							stroke="#4C4981"
							stroke-opacity="0.1"
							stroke-width="1"
						/>
						<path
							d="M5.65143 31.1299C-1.61664 18.5412 -1.91357 5.1058 4.98822 1.12106C11.89 -2.86368 23.3768 4.11121 30.6449 16.6999C37.913 29.2885 38.21 42.7239 31.3082 46.7086C24.4064 50.6934 12.9195 43.7185 5.65143 31.1299Z"
							transform="translate(6.1050415 57.20453)"
							id="Ellipse"
							fill="#FFFFFF"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M28.1467 20.436C35.4167 33.026 44.3367 41.436 37.4367 45.436C30.5367 49.436 10.4367 47.436 3.16669 34.836C-4.10333 22.2361 2.4967 4.83603 9.39667 0.836029C16.2966 -3.16397 20.8667 7.81601 28.1467 20.436L28.1467 20.436Z"
							transform="translate(0 58.48401)"
							id="Shape"
							:fill="currentStoreTheme.color"
							fill-rule="evenodd"
							stroke="none"
						/>
					</g>
					<g id="Head" transform="translate(626.6736 160.961)">
						<path
							d="M0 72.85C0 32.6161 32.6161 0 72.85 0C113.084 0 145.7 32.6161 145.7 72.85C145.7 113.084 113.084 145.7 72.85 145.7C32.6161 145.7 0 113.084 0 72.85Z"
							transform="translate(30.446472 54.338997)"
							id="Circle"
							fill="#AE6E79"
							fill-rule="evenodd"
							stroke="none"
						/>
						<path
							d="M96.8965 94.909C105.566 98.099 110.696 107.059 118.477 112.049C129.477 119.049 143.797 117.239 156.357 113.779C163.357 111.869 170.677 109.539 177.567 111.659C178.58 112.108 179.698 112.267 180.797 112.119C182.297 111.689 183.036 110.029 183.526 108.549C192.047 83.149 188.216 54.379 175.357 30.879C172.036 24.819 168.057 18.959 162.576 14.749C158.256 11.439 153.176 9.26898 148.056 7.41901C138.7 4.05856 129.022 1.66934 119.177 0.289032C117.438 -0.0269165 115.662 -0.084198 113.906 0.118988C111.496 0.509003 109.336 1.80899 107.186 2.96899C97.9783 7.90515 87.7665 10.6787 77.3265 11.079C63.3265 11.609 47.3265 8.30902 36.5365 17.289C23.5365 28.059 26.7765 49.069 18.3465 63.689C12.7665 73.359 2.00647 80.379 0.236511 91.389C-0.224365 94.7542 -0.0101929 98.1775 0.866516 101.459C4.98651 118.399 21.3865 131.519 38.8665 131.829C41.5509 132.034 44.239 131.483 46.6265 130.239C48.1909 129.172 49.5721 127.858 50.7166 126.349C62.1665 112.789 75.2665 86.949 96.8965 94.909L96.8965 94.909Z"
							id="Shape"
							fill="#444053"
							fill-rule="evenodd"
							stroke="none"
						/>
					</g>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	computed: {
		currentStoreTheme() {
			return {
				theme: this.$store.getters["site/getCurrentTheme"],
				color: this.$store.getters["site/getCurrentColor"],
			};
		},
	},
};
</script>
